import React, { Component } from 'react';
import { ZoomControl as ZoomControlButton } from 'react-mapbox-gl';
import PropTypes from 'prop-types';
import Hammer from 'hammerjs';
import UnitBezier from '@mapbox/unitbezier';

// from mapbox-gl's TouchZoomRotateHandler
const inertiaLinearity = 0.15;
const inertiaBezier = new UnitBezier(0, 0, inertiaLinearity, 1);
const inertiaEasing = t => inertiaBezier.solve(t);
const inertiaDeceleration = 12;

class ZoomControl extends Component {
  static contextTypes = {
    map: PropTypes.object.isRequired,
  };

  componentWillMount() {
    this.mc = new Hammer.Manager(this.context.map.getContainer());

    const tap = new Hammer.Tap({ threshold: 40, interval: 100 });
    const pan = new Hammer.Pan();

    this.tapRecognizer = tap;

    pan.requireFailure(tap);

    this.mc.add([tap, pan]);

    this.mc.on('tap', this.onTap);
    this.mc.on('panstart', this.onPanStart);
    this.mc.on('pan', this.onPan);
    this.mc.on('panend', this.onPanEnd);

    this.context.map.on('touchmove', this.onTouchMove);
    this.context.map.on('touchend', this.onTouchEnd);
  }

  componentWillUnmount() {
    this.mc.off('tap', this.onTap);
    this.mc.off('panstart', this.onPanStart);
    this.mc.off('pan', this.onPan);
    this.mc.off('panend', this.onPanEnd);

    this.context.map.off('touchmove', this.onTouchMove);
    this.context.map.off('touchend', this.onTouchEnd);
  }

  onTouchMove = ({ lngLat }) => {
    if (this.needLngLat) {
      this.needLngLat = false;
      this.lngLat = lngLat;
    }
  }

  onTouchEnd = (event) => {
    if (!this.zooming) {
      this.lngLat = event.lngLat;
    }
  }

  onTap = () => {
    this.tapped = true;
    this.tapRecognizer.set({ enable: false });
    this.context.map.dragPan.disable();
    setTimeout(this.onTapTimeout, 200);
  }

  onTapTimeout = () => {
    this.tapped = false;
    this.tapRecognizer.set({ enable: true });
    if (!this.zooming) {
      this.context.map.dragPan.enable();
    }
  }

  onPanStart = ({ deltaY }) => {
    if (!this.tapped && !this.zooming) return;

    if (this.zooming) this.needLngLat = true;
    this.zooming = true;
    this.zoom = this.context.map.getZoom() - (deltaY / 100);
  }

  onPan = ({ deltaY }) => {
    if (!this.zooming) return;

    this.context.map.easeTo({
      zoom: this.zoom + (deltaY / 100),
      duration: 0,
      around: this.lngLat,
    });
  }

  onPanEnd = ({ deltaY, velocityY }) => {
    if (!this.zooming) return;

    this.zooming = false;
    this.context.map.dragPan.enable();
    this.context.map.easeTo({
      zoom: this.zoom + (deltaY / 100) + velocityY,
      duration: Math.abs(velocityY / (inertiaDeceleration * inertiaLinearity)) * 1000,
      easing: inertiaEasing,
      around: this.lngLat,
    });
  }

  lngLat = null;
  needLngLat = false;
  tapped = false;
  zooming = false;

  render() {
    return (
      <ZoomControlButton {...this.props} />
    );
  }
}

export default ZoomControl;



// WEBPACK FOOTER //
// ./src/controls/zoom.js